import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
const VideoV2Provider = (props) => {
  const api = new API();
  const [videoV2SpecilityFilter, setVideoV2SpecilityFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [videoV2SpecilityList, setVideoV2SpecilityList] = useState([]);
  const [videoV2SpecilityLoader, setVideoV2SpecilityLoader] = useState(false);
  const [videoV2TopicFilter, setVideoV2TopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [videoV2TopicList, setVideoV2TopicList] = useState([]);
  const [videoV2TopicLoader, setVideoV2TopicLoader] = useState(false);
  const [videoV2SubTopicFilter, setVideoV2SubTopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [videoV2SubTopicList, setVideoV2SubTopicList] = useState([]);
  const [videoV2SubTopicLoader, setVideoV2SubTopicLoader] = useState(false);
  const [videoV2VideoFilter, setVideoV2VideoFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [videoV2VideoList, setVideoV2VideoList] = useState([]);
  const [videoV2VideoLoader, setVideoV2VideoLoader] = useState(false);

  const fetchVideoV2Specility = async () => {
    setVideoV2SpecilityLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("videos/specialitylist", { ...videoV2SpecilityFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoV2SpecilityList(res?.data?.data);
          setVideoV2SpecilityLoader(false);
        } else {
          setVideoV2SpecilityList([]);
          setVideoV2SpecilityLoader(false);
        }
      });
  }

  const fetchVideoV2Topic = async (subcategory_id=null) => {
    if(!subcategory_id) return;
    setVideoV2TopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("videos/topiclist", { ...videoV2TopicFilter, subcategory_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoV2TopicList(res?.data?.data);
          setVideoV2TopicLoader(false);
        } else {
          setVideoV2TopicList([]);
          setVideoV2TopicLoader(false);
        }
      });
  }

  const fetchVideoV2SubTopic = async (subject_id=null) => {
    if(!subject_id) return;
    setVideoV2SubTopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("videos/subtopiclist", { ...videoV2SubTopicFilter, subject_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoV2SubTopicList(res?.data?.data);
          setVideoV2SubTopicLoader(false);
        } else {
          setVideoV2SubTopicList([]);
          setVideoV2SubTopicLoader(false);
        }
      });
  }

  const fetchVideoV2Video = async (topic_id=null) => {
    if(!topic_id) return;
    setVideoV2VideoLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("videos/videov2tablelist", { ...videoV2VideoFilter, topic_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoV2VideoList(res?.data?.data);
          setVideoV2VideoLoader(false);
        } else {
          setVideoV2VideoList([]);
          setVideoV2VideoLoader(false);
        }
      });
  }

  return (
    <Context.Provider
      value={{
        ...props,
        videoV2SpecilityFilter, setVideoV2SpecilityFilter,
        videoV2SpecilityList, setVideoV2SpecilityList,
        videoV2SpecilityLoader, setVideoV2SpecilityLoader,
        fetchVideoV2Specility,
        videoV2TopicFilter, setVideoV2TopicFilter,
        videoV2TopicList, setVideoV2TopicList,
        videoV2TopicLoader, setVideoV2TopicLoader,
        fetchVideoV2Topic,
        videoV2SubTopicFilter, setVideoV2SubTopicFilter,
        videoV2SubTopicList, setVideoV2SubTopicList,
        videoV2SubTopicLoader, setVideoV2SubTopicLoader,
        fetchVideoV2SubTopic,
        videoV2VideoFilter, setVideoV2VideoFilter,
        videoV2VideoList, setVideoV2VideoList,
        videoV2VideoLoader, setVideoV2VideoLoader,
        fetchVideoV2Video,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default VideoV2Provider;
